import React, { useState, useEffect } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { Typography, Grid, Select, MenuItem,Hidden } from "@material-ui/core";
import { store } from "../../../../helpers/store";
import { useMediaQuery } from "react-responsive";
import ExpandMoreSharpIcon from "@material-ui/icons/ExpandMoreSharp";
import { updateMeterDetails } from "../../../../actions/home.action";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { Skeleton } from "@material-ui/lab";
import { BillingStyles } from "../../../billing-history/billing-style";
import { white } from "material-ui/styles/colors";

const useStyles = makeStyles((theme) => ({
  linkColor: {
    color: theme.palette.tertiary.main,
  },
  listItem1: {
    color: theme.palette.quaternary.main + " !important",
  },
  listItem2: {
    color: theme.palette.quaternary.main + " !important",
    whiteSpace: "normal",
    paddingBottom: "10px",
  },
  quaternaryColor: {
    color: theme.palette.quaternary.main,
  },
  wrapTitle: {
    whiteSpace: "break-spaces",
  },
  singleAccount:{
      fontSize: 12,
      border: "1px solid " + theme.palette.primary.main + " !important",
      borderRadius: "4px",
      padding: "7px 10px",
      justifyContent: "flex-start",
      color:white,
      backgroundColor: theme.palette.primary.main + " !important",
      marginRight:5
  },
  accountLabel:{
    color:theme.palette.primary.main,
    fontSize:15,
    marginRight:5,
    marginTop:6.5
  },
  mobileAccountLabel:{
    color:theme.palette.primary.main,
    fontSize:13,
    marginRight:5,
    marginTop:1.5,
    align:"center"
  },
  addressDetails:{
    color:theme.palette.primary.main,
    fontSize:12,
    marginTop:6.5
  }
}));

export const STYLED_SELECT = withStyles((theme) => ({
  root: {
    fontSize: 14,
    border: "1px solid " + theme.palette.primary.main + " !important",
    borderRadius: "4px",
    padding: "6px 9px",
    justifyContent: "flex-start",
    color:white,
    backgroundColor: theme.palette.primary.main + " !important",
    marginRight:5
  },
  select: {
    "&:focus": {
      borderRadius: "4px",
    },
    whiteSpace: "pre-line",
  },
  icon: {
    color:white,
    marginRight:5,
    marginTop:2.5
  },
}))(Select);

export const STYLED_MENU_ITEM = withStyles((theme) => ({
  root: {
    color: theme.palette.primary.main + " !important",
    fontSize: "15px",
    justifyContent: "flex-start",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.2)",
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.primary.main,
      },
    },
    "&:focus": {
      backgroundColor: "rgba(0, 0, 0, 0.2)",
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.primary.main,
      },
    },
  },
}))(MenuItem);

export default function ASDropdownComponent() {
  const classes = useStyles();
  const billClasses = BillingStyles();
  const dispatch = useDispatch();
  const isTabletOrMobile = useMediaQuery({ maxWidth: 567 });
  const [connection, setConnection] = useState("");
  const primaryIdentifier = useSelector((state) =>state?.parametersWidgets?.ParameterLookup?.PRIMARY_IDENTIFIER);
  let accountId = useSelector((store) => store?.meterDetails[primaryIdentifier]);
  let accountInfo = useSelector(
    (state) => state?.accountInformation?.personAcccountDetail?.personAccountList
  );
  let accountInformation = useSelector(
    (state) => state?.accountInformation
  );
  let labels = useSelector(
    (state) => state?.labels?.data?.getLabels?.DROPDOWN
  );
  let nameLabel = useSelector(
    (state) => state?.labels?.data?.getLabels?.DROPDOWN?.DROPDOWN_ACCOUNT_ID
  );
  let detailsLabel = useSelector(
    (state) => state?.labels?.data?.getLabels?.ACCOUNT_DETAILS
  );
  let meterDetails=useSelector(
    (state) => state?.meterDetails
  );
 
  
  useEffect(() => {
    if (accountId) {
      setConnection(accountId);
    }
  }, [accountId]);


  const ddlMenuProps = {
    disableScrollLock: false,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "right",
    },
    getContentAnchorEl: null,
  };

  let multipleAccountDetails = [];
  multipleAccountDetails = useSelector(
    (state) => state?.accountInformation?.personAcccountDetail?.personAccountList
  );

  const handleConnectionOnChange = (event) => {
    store.getState().snackbar = true;
    setConnection(event.target.value);
    if (accountInfo) {
     accountInfo.filter((single,k)=>{
      if(Number(single.accountId)===Number(event.target.value)){
        dispatch(updateMeterDetails(single,single.accountSaList[0]));
      }
     })
    }
  };

  return (
    <Grid container justify="flex-end" alignContent="flex-end">
     <Hidden xsDown>
     <Grid item>
      <Typography align="left" className={classes.accountLabel}><b>{nameLabel}</b></Typography>
      </Grid>
     </Hidden>
     <Hidden smUp>
     <Grid item>
      <Typography className={classes.mobileAccountLabel}><b>{nameLabel}</b></Typography>
      </Grid>
     </Hidden>
      <Grid item>
        {multipleAccountDetails ? (
          multipleAccountDetails.length === 1 ? 
          (
            <>
            <Typography className={classes.singleAccount}>
            {multipleAccountDetails.map((item)=>{
                      return (
                        item.accountId
                      )
                    })}
              </Typography>
            </>
          )
          : (
            <>                       
            <STYLED_SELECT
                className="accountDrop"
                name={"ddlConnection"}
                value={connection}
                renderValue={(value) => `${value}`}
                onChange={handleConnectionOnChange}
                displayEmpty={true}
                IconComponent={ExpandMoreSharpIcon}
                disableUnderline={true}
                MenuProps={ddlMenuProps}
                // fullWidth={isTabletOrMobile}
              >
                {multipleAccountDetails === undefined
                  ? null
                  : accountInformation.personAcccountDetail.personAccountList.map(
                    (singleMeter, k) => {
                          return (
                            <STYLED_MENU_ITEM
                        key={singleMeter.accountId}
                        value={
                            singleMeter.accountId
                        }
                      >
                        <Grid
                          container
                          direction="column"
                          alignItems="flex-start"
                        >
                          <Grid
                            container
                            direction="row"
                            justify="space-between"
                            spacing={2}
                          >
                            <Grid item className={classes.listItem1}>
                              <b>{labels?.DROPDOWN_ACCOUNT_ID}</b>
                            </Grid>

                            <Grid item className={classes.listItem1}>
                              <b>{singleMeter[primaryIdentifier]}</b>
                            </Grid>
                          </Grid>
                          <Grid
                            container
                            direction="row"
                            justify="space-between"
                            spacing={2}
                          >
                            <Grid item className={classes.listItem1}>
                              <b>{detailsLabel?.DASHBOARD_CUSTOMER_CLASS}</b>
                            </Grid>

                            <Grid item className={classes.listItem1}>
                              {singleMeter?.customerClassDesc}
                            </Grid>
                          </Grid>
                          <Grid
                            container
                            direction="row"
                            justify="space-between"
                            spacing={2}
                          >
                            <Grid item className={classes.listItem1}>
                              <b>{detailsLabel?.CONNECTION_BILLING_ADDRESS}</b>
                            </Grid>

                            <Grid item className={classes.listItem1}>
                              {singleMeter?.accountPersonDetail?.accountPremiseDetailList?.address1 || singleMeter?.accountPersonDetail?.accountPremiseDetailList?.[0]?.address1}
                            </Grid>
                          </Grid>
                          
                        </Grid>
                      </STYLED_MENU_ITEM>
                          )}
                        //   )}
                          )
                }
              </STYLED_SELECT>
              
            </>
          )
        ) : (
          <Skeleton></Skeleton>
        )}
      </Grid>
     <Hidden xsDown>
     <Grid item>
      <Grid item className={classes.accountLabel}>
        <b>{meterDetails?.accountPersonDetail?.accountPremiseDetailList?.address1 || meterDetails?.accountPersonDetail?.accountPremiseDetailList?.[0]?.address1}</b>
      </Grid>
      </Grid>
     </Hidden>
     <Hidden smUp>
     <Grid item>
      <Grid item className={classes.mobileAccountLabel}>
        <b>{meterDetails?.accountPersonDetail?.accountPremiseDetailList?.address1 || meterDetails?.accountPersonDetail?.accountPremiseDetailList?.[0]?.address1}</b>
      </Grid>
      </Grid>  
     </Hidden>
    </Grid>
  );
}
